import $logger from 'beaver-logger';
import { inIframe, uniqueTimestampId } from '../framework/App/AppUtils';

const capeLogger = {
    log: function(message, error) {
        try {
            if (typeof $logger === 'object') {
                const messageObj = getDefaultMessage(message);
                if (error) {
                    messageObj.message += ', Error object: ' + error.toString();
                    $logger.error('BROWSER_CLIENT', messageObj);
                } else {
                    $logger.info('BROWSER_CLIENT', messageObj);
                }
            }
        } catch (e) {
            // swallow any error when we try to log error/message
        }
    },
    fpti: function(message, error) {
        try {
            if (typeof $logger === 'object') {
                if (error) {
                    message += ', Error object: ' + error.toString();
                }
                $logger.track({BROWSER_CLIENT_FPTI: message});
            }
        } catch (e) {
            // swallow any error when we try to log
        }
    },
    logSplunk: function(message, error) {
        try {
            if (typeof $logger === 'object') {
                const messageObj = getDefaultMessage(message);
                if (error) {
                    messageObj.message += ', Error object: ' + error.toString();
                    $logger.error('BROWSER_CLIENT_SPLUNK', messageObj);
                } else {
                    $logger.info('BROWSER_CLIENT_SPLUNK', messageObj);
                }
            }
        } catch (e) {
            // swallow any error when we try to log error/message
        }
    },
    init: function(logger) {
        if (typeof logger === 'object') {
            logger.init({

                // URI to post logs to
                uri: getLogUri(),

                // State name to post logs under
                initial_state_name: 'default_state',

                // Interval at which to automatically flush logs to the server
                flushInterval: 10 * 60 * 1000,

                // Interval at which to debounce $logger.flush calls
                debounceInterval: 10,

                // Enable or disable heartbeats, which run on an interval and monitor for event loop delays
                heartbeat: false,

                // Log levels which trigger an auto-flush to the server
                autoLog: ['info', 'warn', 'error'],

                // Log window.onunload and window.beforeUnload events?
                logUnload: false,

                // Log unload synchronously, to guarantee the log gets through?
                logUnloadSync: false,

                // Log performance stats from the browser automatically?
                logPerformance: false
            });
        }
    }
};

function getDefaultMessage(message) {
    return {
        uniqueTimestampId: uniqueTimestampId(),
        viewName: getViewName(),
        message,
        correlationId: getCorrelationId(),
        is_iframe: inIframe()
    };
}

function getViewName() {
    const url = window.location.pathname;
    const viewName = url.substr(url.lastIndexOf('/') + 1);
    return viewName;
}

function getLogUri() {
    return '/ppcreditapply/log';
}

function getCorrelationId() {
    let id = 'unknown';
    const csrfElement = document.getElementsByTagName('body')[0];
    if (csrfElement) {
        id = csrfElement.getAttribute('data-correlation-id');
    }
    return id;
}

function getStack(error) {
    const stack = (error && error.stack) || '';

    return stack.replace(/http.*\/js/g, '') // remove the http://www.paypalobjects.com/ stuff from the stack traces.
        .replace(/[\n\r]/g, '') // remove new lines
        .slice(0, 1024); // trim any unexpected long strings
}

function errorHandler(msg, url, lineNumber, columnNumber, error) {
    try {
        const extra = !columnNumber ? '' : '\ncolumn: ' + columnNumber;
        const message = 'Error: ' + msg + '. Url: ' + url + '. Line: ' + lineNumber + extra + ', stack=' + getStack(error);
        capeLog(message, error);
    } catch (e) {
        // swallow any error when we are handling error.
    }
    return false;
}

capeLogger.init($logger);
window.capeLog = capeLogger.log;
window.capeLogSplunk = capeLogger.logSplunk;
window.onerror = errorHandler;
export default capeLogger;
